import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InputForm from '../common/forms/InputForm';
import StepHeader from '../common/StepHeader';
import { Error } from 'components/common/Form.js';
import CustomerBasicDataValidation from './utils/CustomerBasicDataValidation';
import axios from 'components/AppRequest';
import { connect } from 'react-redux';
import { updateRegisterData, updateRegisterFields, resetRegisterErrors } from 'components/actions/authActions';
import withRouter from 'components/components/common/withRouter';
import PasswordMask from 'components/components/common/PasswordMask';
import LoadingSpinner from '../common/LoadingSpinner';
import TransHelper from 'components/common/translations/TransHelper';
import AppLink from 'components/common/AppLink';
import InputPhoneNr from 'components/components/common/forms/InputPhoneNr';
import mergeErrors from 'components/helpers/mergeErrors';

function SampleEyeShow() {
  return (
    <FontAwesomeIcon
      icon={['fas', 'eye']}
      title="Show"
    />
  );
}

function SampleEyeHide() {
  return (
    <FontAwesomeIcon
      icon={['fas', 'eye-slash']}
      title="Hide"
    />
  );
}

class RegistrationFormStep1 extends Component {

  constructor(props) {
    super(props);
    this.cbdv = new CustomerBasicDataValidation(false, this.props.locale);
    this.inputPhoneRef = React.createRef();
    this.state = {
      isLoading: false
    }
  }

  trans = (key, prefix = 'content.auth.registrationFormStep1') => {
    return TransHelper.translate(this.props.locale, prefix + '.' + key);
  }

  transError = (key) => {
    return TransHelper.translate(this.props.locale, 'content.errors.auth.registrationFormStep1.' + key);
  }

  changeName = (e) => {
    var val = e.target.value;
    this.props.updateRegisterFields({ name: val });
  }

  changeEmail = (e) => {
    var val = e.target.value;
    this.props.updateRegisterFields({ email: val });
  }

  changePassword = (e) => {
    var val = e.target.value;
    this.props.updateRegisterFields({ password: val });
  }

  changePhoneCountry = (phoneCountry) => {
    this.props.updateRegisterFields({ phoneCountry: phoneCountry })
  }

  changePhoneNumber = (value) => {
    this.props.updateRegisterFields({ phone: value })
  }

  submitForm = (e) => {
    e.preventDefault();
    //reset errors
    this.props.resetRegisterErrors();

    // Validate phone
    var phoneError = this.inputPhoneRef.current.validateForm();

    if (this.cbdv.isValidForm(this.props.register) && phoneError === null) {
      this.checkEmailAndPhone();
    } else {
      var errors = this.cbdv.getFieldsErrors(this.props.register);
      if (phoneError !== null) {
        errors.phone = phoneError;
      }
      this.props.updateRegisterFields({ errors: errors });
    }
  }

  checkEmailAndPhone = () => {
    const { email, phoneCountry, phone } = this.props.register;
    var wholePhone = phoneCountry.label + phone;

    this.setState({ isLoading: true }, () => {
      axios.post('/pwa/registration/check-email-and-phone', {
        email: email,
        phone: wholePhone
      })
        .then(response => {
          this.setState({ isLoading: false });
          TransHelper.redirect(this.props, 'routes.url.registrationStep2');
        })
        .catch(err => {
          var errors = {};
          if (err.response && err.response.data) {
            if (err.response.data.errors) {
              // Backend może zwrócić errors jako obiekt z kluczami email i/lub phone
              errors = err.response.data.errors;
              // Jeśli phone errors są jako array/string, zmerguj je
              if (errors.phone && typeof errors.phone !== 'string') {
                errors.phone = mergeErrors(errors.phone);
              }
            } else if (err.response.data.msg) {
              errors.email = err.response.data.msg;
            }
          } else {
            errors.email = this.transError('emailBusy');
          }
          this.props.updateRegisterFields({ errors: errors });
          this.setState({ isLoading: false });
        });
    })
  }

  render() {
    const { errors, name, email, password, phoneCountry, phone } = this.props.register;
    return (
      <div className="layout layout--bg-corner">
        <div className="wrapper">
          <StepHeader
            link="routes.url.signup"
            linkTitle="Back to Register"
            step={1}
            maxSteps={2}
            title={this.trans('header')}
          />
          <div className="content">
            <form>
              <fieldset>
                <legend className="visuallyhidden">Personal Info Form</legend>

                <ul className="list-fields list-none">
                  <li className="list-fields__item">
                    <InputForm
                      id="fullname"
                      name="_fullname_pks"
                      type="text"
                      label={this.trans('labels.fullname')}
                      value={name}
                      handleChange={this.changeName}
                    />
                    <Error error={errors.name} />
                  </li>

                  <li className="list-fields__item">
                    <InputForm
                      id="email"
                      name="_email_pks"
                      type="email"
                      label={this.trans('labels.email')}
                      value={email}
                      handleChange={this.changeEmail}
                    />
                    <Error error={errors.email} />
                  </li>

                  <li className="list-fields__item">
                    <InputPhoneNr
                      ref={this.inputPhoneRef}
                      changePhoneCountry={this.changePhoneCountry}
                      changePhoneNumber={this.changePhoneNumber}
                      errorPhone={errors.phone}
                      phoneNumber={phone}
                      phoneCountry={phoneCountry}
                      className="list-fields__phone-nr"
                      locale={this.props.locale}
                    />
                  </li>

                  <li className="list-fields__item">
                    <label htmlFor="password">{this.trans('labels.password')}</label>
                    <PasswordMask
                      id="password"
                      name="_password_pks"
                      value={password}
                      onChange={this.changePassword}
                      showButtonContent={<SampleEyeShow />}
                      hideButtonContent={<SampleEyeHide />}
                      buttonClassName="button--toggle"
                      className="button-toggle-wrap"
                    />
                    <Error error={errors.password} />
                  </li>
                </ul>

                <p className="text-center text-small mb-15">
                  {this.trans('terms.first')}{' '}
                  <a href="terms-of-use">{this.trans('terms.second')}</a> {this.trans('terms.and')}&nbsp;
                  <a href="privacy-policy">{this.trans('terms.third')}</a>
                </p>

                {this.state.isLoading
                  ?
                  <LoadingSpinner className="button button--outline button--expand" />
                  :
                  <button
                    className="button button--outline button--expand"
                    onClick={this.submitForm}
                  >
                    {this.trans('next', 'content.common')}
                  </button>
                }
              </fieldset>
            </form>

            <div className="footer-bottons">
              <p>{this.trans('haveAccount')}</p>
              <p><AppLink to="routes.url.login">{this.trans('logIn')}</AppLink></p>
            </div>
          </div>
        </div>

        <footer className="footer" />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    register: state.auth.register
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    { updateRegisterFields, updateRegisterData, resetRegisterErrors }
  )(RegistrationFormStep1)
);
